import { useEffect } from 'react';
import { Platform } from 'react-native';
import { useBreakpoints } from '@/common/hooks/useBreakpoints';
import { TabsLayout } from '@/common/layouts/TabsLayout/TabsLayout';
import { Slot, useNavigation } from 'expo-router';

export default function Layout() {
  const breakpoints = useBreakpoints(['lg']);
  const navigation = useNavigation();
  useEffect(() => {
    navigation.setOptions({
      animation: 'slide_from_bottom',
    });
  }, [navigation]);

  if (breakpoints.lg && Platform.OS === 'web') {
    return <TabsLayout />;
  }

  return <Slot />;
}
